// extracted by mini-css-extract-plugin
export default {"modal":"getQuoteError_modal__p8cQe"};